import * as actionTypes from '../mainActionTypes';

export function goToRoute(route) {
  return {
    type: actionTypes.GO_TO_ROUTE,
    payload: route
  };
}

export function goBack() {
  return {
    type: actionTypes.GO_BACK
  };
}

export function navigateToLogoEditor(selectedZoeTemplate, companyDetails) {
  return {
    type: actionTypes.NAVIGATE_TO_LOGO_EDITOR,
    payload: {
      selectedZoeTemplate,
      companyDetails
    }
  };
}

export function goToDomain(domainName) {
  return {
    type: actionTypes.GO_TO_DOMAIN,
    payload: domainName
  };
}

export function goToDomainPageV3(domainName, screenType, NavigateToMarketingLP = false) {
  return {
    type: actionTypes.GO_TO_DOMAIN_PAGE_V3,
    payload: { domainName, screenType, NavigateToMarketingLP }
  };
}

export function navigateToCreateNewWebsite() {
  return {
    type: actionTypes.NAVIGATE_TO_CREATE_NEW_WEBSITE
  };
}

export function navigateTologoOnboarding(companyDetails, industry, tags) {
  return {
    type: actionTypes.NAVIGATE_TO_LOGO_ONBOARDING,
    payload: { companyDetails, industry, tags }
  };
}
